var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { timer } from 'rxjs';
import { OnInit } from '@angular/core';
import { CommunicationService } from '../../services/communication.service';
import { HasSubscriptions } from '../has-subscriptions';
import { DeviceService } from '../../services/device/device.service';
var NotificationsComponent = /** @class */ (function (_super) {
    __extends(NotificationsComponent, _super);
    function NotificationsComponent(communicationService, deviceService) {
        var _this = _super.call(this) || this;
        _this.communicationService = communicationService;
        _this.deviceService = deviceService;
        _this.isTemporary = true;
        // TODO: I hate everything about this bottom notification
        _this.isBottomNotification = false;
        _this.notificationLifeSpan = 750;
        _this.enableNotification = true;
        _this.state = 'hidden';
        _this.stateBottom = 'hiddenBottom';
        return _this;
    }
    NotificationsComponent.prototype.ngOnInit = function () {
        var _this = this;
        if (!this.isBottomNotification) {
            this.addSub(this.communicationService.notifications.notificationChanged.subscribe(function (notification) { return __awaiter(_this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    this._setNotification(notification);
                    return [2 /*return*/];
                });
            }); }));
        }
        else {
            this.addSub(this.communicationService.notifications.bottomNotification.subscribe(function (n) { return __awaiter(_this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    this._setNotification(n);
                    return [2 /*return*/];
                });
            }); }));
        }
        this.addSub(this.communicationService.notifications.enableNotifications.subscribe(function (status) {
            if (_this.subscription) {
                _this.subscription.unsubscribe();
            }
            _this.subscription = timer(150).subscribe(function () {
                _this.enableNotification = status;
            });
        }));
    };
    NotificationsComponent.prototype._setNotification = function (notification) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.currentNotification = notification;
                        if (notification && notification.length > 0) {
                            if (this.isBottomNotification)
                                this.stateBottom = 'showBottom';
                            else
                                this.state = 'show';
                        }
                        else {
                            this.state = 'hidden';
                            this.stateBottom = 'hiddenBottom';
                        }
                        if (!(this.deviceService.isMobileDevice() && this.isTemporary)) return [3 /*break*/, 2];
                        return [4 /*yield*/, timer(this.notificationLifeSpan).toPromise()];
                    case 1:
                        _a.sent();
                        if (this.currentNotification === notification) {
                            // i.e. unless this notification has been interrupted by another one ...
                            this.currentNotification = null;
                            this.state = 'hidden';
                            this.stateBottom = 'hiddenBottom';
                        }
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    return NotificationsComponent;
}(HasSubscriptions));
export { NotificationsComponent };
